module.exports = __webpack_public_path__ + "img/now-serving-logo-horizontal.5963fcfb.svg";